import { DocumentService } from 'src/app/core/services/document.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-sign-contract-lot-notify',
  templateUrl: './sign-contract-lot-notify.component.html',
  styleUrls: ['./sign-contract-lot-notify.component.scss']
})
export class SignContractLotNotifyComponent implements OnInit {
  listUser = [];
  dataSelected = [];
  checkAll: boolean;
  sendEmail = true;
  // Number of checked documents
  public countCheck = 0;
  constructor(
    public dialogRef: MatDialogRef<SignContractLotNotifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public notificationService: NotificationService,
    private message: Message,

  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.getDisplayedColumns();
  }

  columnDefinitions = [
    { def: 'contractName', showMobile: true },
    { def: 'name', showXS: true, showSM: true, showMD: true },
    { def: 'isCreatedSide', showXS: true, showSM: true, showMD: true },
    { def: 'role', showXS: true, showSM: true, showMD: true },
    { def: 'isSendSms', showXS: true, showSM: true, showMD: true },
  ];
  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  ngOnInit() {
    this.listUser = [...this.data];
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }

    }
  }

  onSelectionChange(){
    this.checkAll = this.listUser.filter(item => item.isSendSms).length === this.listUser.length 
  }
  /**
   * check box change event.
   * @param item document item.
   * @param isChecked status of checkbox.
   */

  public checkAllDocument() {
    this.listUser.forEach(data => {
      data.isSendSms = this.checkAll;
    });
  }

  sendNotify(): void {
    const data = this.listUser.map(item => {
      return {
        contractId: item.id,
        userFromFE: {
          id: item.idNotify,
          email: item.email,
          userName: item.name,
          userRole: item.role,
          isCreatedSide: item.isCreatedSide,
          checked: true,
          isSendSms: item.isSendSms || false,
        }
      }
    })
    this.documentService.sendUserSignContractLot(data).subscribe(res => {
      if (res.success) {
        this.dialogRef.close(res.success);
      }
    });
  }

}
